////////LIBRARY/////////
import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { useSelector, shallowEqual } from 'react-redux'
import { find } from 'lodash'

/**
 *
 * @param name                          key name off privilage to display
 * @param userAuthorization             list off privileges off user
 * @param children                      element to display
 * @returns frameElement
 * @constructor
 */
const UserAuthorizationLayout = ({ name, children }) => {
	const { userAuthorization } = useSelector(
		(state) => ({
			userAuthorization: state.user.identity.rolePrivileges.privileges,
		}),
		shallowEqual
	)

	const authorized = find(userAuthorization, { label: name }) ? true : false

	///////////////////////////////// RENDER ///////////////////////////////////////

	return <Fragment>{authorized && children}</Fragment>
}

UserAuthorizationLayout.propTypes = {
	name: PropTypes.string,
	children: PropTypes.oneOfType([PropTypes.element, PropTypes.arrayOf(PropTypes.element)]),
	userAuthorization: PropTypes.array,
}

export default UserAuthorizationLayout
